<template>
  <div id="lista-formulario-card">
    <div class="lista-formulario-card-numero">
      <slot name="numerator"></slot>
    </div>
    <div style="border-radius: 6px" class="lista-formulario-card-form">
      <el-collapse accordion>
        <el-collapse-item name="1" style="background: none">
          <template v-slot:title>
            <slot name="card-title"></slot>
          </template>
          <slot name="collapsed"></slot>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CardAccordion'
}
</script>
<style lang="less">
#lista-formulario-card {
  .label-card-formulario {
    font-size: 11px;
    text-align: left;
    color: #333333;
    font-family: "Open Sans", SansSerif;
    display: block;
  }

  .value-card-formulario {
    font-size: 14px;
    text-align: left;
    color: #333333;
    line-height: 19px;
  }

  .box-card-formulario {
    padding-bottom: 10px;
    border-radius: 6px;
  }
  .lista-formulario-card-form {
    border-radius: 0 6px 6px 0;
  }
  .card-download {
    border-radius: 8px;
    box-shadow: none;
    border: none;
    margin-top: 10px;
  }
  .btn-card-downnload {
    float: right;
    color: #006FB9;
  }
  .card-download-title {
    font-family: 'Open Sans', SansSerif;
    font-weight: 600;
  }
  .btn-title {
    vertical-align: top;
    padding-right: 5px;
    font-size: 12px;
    position: relative;
    bottom: 4px;
  }
}
</style>
